import React from "react";
import Navbar from "../components/Navbar";
import HeaderInner from "../components/HeaderInner";

function ContactSection() {
  return (
    <>
      <Navbar />
     <HeaderInner title="Contact" /> {/* ✅ Pass a title if HeaderInner is reusable */} 

      {/* Contact Info Section */}
      <div className="section-info mt-5">
        <div className="container">
         <div className="row">
  {/* Call Us */}
  <div className="col-lg-4">
    <div className="contact-info">
      <div className="contact-info_icon">
        <i className="fas fa-phone"></i>
      </div>
      <div className="media-body">
        <h4 className="box-title">Call Us Anytime</h4>
        <span className="contact-info_text">
          <a href="tel:+65485965789">(+65) 48596 5789</a><br />
          <a href="tel:+65485965789">+65-48596-5789</a>
        </span>
      </div>
    </div>
  </div>

  {/* Email Us */}
  <div className="col-lg-4">
    <div className="contact-info">
      <div className="contact-info_icon">
        <i className="fas fa-envelope"></i>
      </div>
      <div className="media-body">
        <h4 className="box-title">Email Us</h4>
        <span className="contact-info_text">
          <a href="mailto:info@example.com">info@example.com</a><br />
          <a href="mailto:support@example.com">support@example.com</a>
        </span>
      </div>
    </div>
  </div>

  {/* Visit Us */}
  <div className="col-lg-4">
    <div className="contact-info">
      <div className="contact-info_icon">
        <i className="fas fa-map-marker-alt"></i>
      </div>
      <div className="media-body">
        <h4 className="box-title">Visit Our Office</h4>
        <span className="contact-info_text">
          123 Business Street,<br />
          Downtown, Singapore 123456
        </span>
      </div>
    </div>
  </div>
</div>

        </div>
      </div>

      {/* Contact Form Section */}
      <div className="contact-form">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="contact-map">
               <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3499.966584117844!2d77.14845247429609!3d28.69064618144152!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d019156516583%3A0x5c781e0cb68784d0!2zTUFURUJJWiDvuI8!5e0!3m2!1sen!2sin!4v1748515326716!5m2!1sen!2sin"
    width="600"
    height="450"
    style={{ border: 0 }}
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    title="Google Map"
  ></iframe>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="col-form">
                <form>
                  <div className="row">
                    <div className="col-lg-6">
                      <input type="text" name="name" placeholder="Name" required />
                    </div>
                    <div className="col-lg-6">
                      <input type="text" name="mobile" placeholder="Mobile Number" required />
                    </div>
                    <div className="col-lg-6">
                      <input type="email" name="email" placeholder="Email Address" required />
                    </div>
                    <div className="col-lg-6">
                      <input type="text" name="make_model" placeholder="Make & Model" required />
                    </div>
                    <div className="col-lg-6">
                      <input type="text" name="rego_number" placeholder="Rego Number/Plate Number" required />
                    </div>
                    <div className="col-lg-6">
                      <input type="text" name="pickup_location" placeholder="Pickup Location/Address" required />
                    </div>
                    <div className="col-lg-12">
                      <textarea name="vehicle_details" placeholder="Tell Us About Your Vehicle" rows="3"></textarea>
                    </div>
                    <div className="col-lg-12">
                      <button type="submit">Get An Offer</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactSection;
